module.exports = window.$;


//////////////////
// WEBPACK FOOTER
// external "window.$"
// module id = 356
// module chunks = 1 2 3 4 5 7